import type { LimuloQueueTicket } from './code.ts';

/**
 * **L'avviso «se accetti esci dalla coda» — quando c'e'** (T2-5, lotto B3b-2). Vero SOLO se il biglietto di
 * coda dell'utente e' in ATTESA (`waiting`) per lo STESSO gioco della sfida in arrivo: e' il caso in cui il motore,
 * su accept, toglie il biglietto dalla coda (`core/code.js`, filtro `{ gameId, state: 'waiting' }` [letto dal sorgente
 * da un sub-agente del seggio, non visto sul vivo]). Le code degli altri giochi restano.
 *
 * ⚠️ I due `gameId` stanno nello stesso spazio: `ticketOf` e `challengeOf` li passano senza normalizzarli e il BFF li
 * copia com'e' — il confronto e' uguaglianza esatta, lo stesso del motore. Un biglietto `matched` NON conta: li' l'accept
 * non toglie niente, risponde 409 `sfida.abbinato-in-coda` (la sua frase sta in `challenge.ts`).
 *
 * Pura: nessuna decisione su DOVE si mostra (tab e DM) ne' con che nome del gioco.
 */
export function uscitaDallaCodaAccettando(
  ticket: Pick<LimuloQueueTicket, 'state' | 'gameId'> | null,
  sfida: { gameId: string },
): boolean {
  return ticket !== null && ticket.state === 'waiting' && ticket.gameId === sfida.gameId;
}
